// extracted by mini-css-extract-plugin
module.exports = {"establishments":"AuthorityPosts_establishments__2lP4i","header":"AuthorityPosts_header__wiQSt","tableHeader":"AuthorityPosts_tableHeader__1WzrM"};